import React from 'react';


const WishCompletedMessage = ({ message }) => {
  const className = `message ${message.isMine ? 'message--mine' : ''}`;

  return (
    <li className={className}>
      <div>
        {message.isSeen && (
          <span className="message-read-indicator">Seen</span>
        )}
        <p>You helped my Tempting Wish come true! Your Reward is on the way!</p>
        <span className="message-time">{message.displayTime}</span>
      </div>
    </li>
  );
};

export default WishCompletedMessage;